

import React, { useState, useRef, useEffect } from "react";
import "./Payment.css";
import order from "./order-delivered copy.jpg";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import axios from "axios";
import { CheckCircle, Printer, Download, Star } from 'lucide-react';

const Sheduleorder = ({ orderId: propOrderId }) => {
    const [orderDetails, setOrderDetails] = useState(null);
    const [platformCharge, setPlatformCharge] = useState(0);
    const [isApplieds, setIsApplieds] = useState(false);
    const [showNewPage, setShowNewPage] = useState(false);
    const [orderData, setOrderData] = useState({});
    const [showPaymentData, setShowPaymentData] = useState(false);
    const [userId, setUserId] = useState(localStorage.getItem("userId") || 1);
    const [feedback, setFeedback] = useState("");
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [loading, setLoading] = useState(false);
    const [bannerData, setBannerData] = useState(null);
    const [error, setError] = useState("");

    const discountAmount = orderData?.discountAmount ?? 0;
    const {
        subTotal = 0,
        serviceCharge = 0,
        deliveryCharges = 0,
        packingCharges = 0,
        cgst = 0,
        sgst = 0,
        service = "",
    } = orderData || {};

    const orderId = propOrderId || localStorage.getItem("orderId");
    const vendorId = localStorage.getItem("vendorId");
    const printRef = useRef();

    // 格式化日期函数
    const formatDate = (dateString) => {
        if (!dateString) return "";
        try {
            const d = new Date(dateString);
            const day = String(d.getDate()).padStart(2, "0");
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const year = d.getFullYear();
            return `${day}/${month}/${year}`;
        } catch (error) {
            console.error("日期格式化错误:", error);
            return "";
        }
    };

    // 计算项目总价函数
    const calculateItemTotal = (item) => {
        const price = parseFloat(item.price) || 0;
        const quantity = parseInt(item.quantity) || 1;
        return price * quantity;
    };

    const handlePayNowClick = () => {
        setShowNewPage(true);
    };

    const handleSubmitFeedback = async () => {
        const orderId = localStorage.getItem("orderId");
        if (!orderId) {
            alert("❌ No order ID found in local storage.");
            return;
        }

        const payload = {
            feedback: feedback,
            ratings: rating,
        };

        try {
            const response = await axios.post(
                ` https://backend.maamaas.com/food/orders/feedback/${orderId}`,
                payload
            );
            alert("✅ Feedback submitted successfully!");
            setFeedback("");
            setRating(0);
        } catch (error) {
            console.error("❌ Failed to submit feedback:", error);
            alert("❌ Failed to submit feedback.");
        }
    };

    useEffect(() => {
        if (!orderId) return;

        const fetchOrderDetails = async () => {
            try {
                console.log("🌐 Fetching order details for:", orderId);
                const token = localStorage.getItem("authToken");

                const response = await axios.get(
                    ` https://backend.maamaas.com/food/api/orders/order/${orderId}`,
                    {
                        headers: {
                            Authorization: token ? `Bearer ${token}` : "",
                        },
                    }
                );

                if (response.status === 200) {
                    console.log("✅ Order details fetched:", response.data);
                    setOrderData(response.data);
                    localStorage.setItem("orderData", JSON.stringify(response.data));

                    if (response.headers?.authorization) {
                        const newToken = response.headers.authorization.replace("Bearer ", "");
                        localStorage.setItem("authToken", newToken);
                        console.log("🔒 Updated auth token stored in localStorage");
                    }
                } else {
                    console.error("⚠️ Unexpected response:", response);
                }
            } catch (error) {
                console.error("❌ Failed to fetch order details:", error);
            }
        };

        fetchOrderDetails();
    }, [orderId]);

    const handlePrint = () => {
        const printContent = printRef.current.innerHTML;
        const originalContent = document.body.innerHTML;
        document.body.innerHTML = printContent;
        window.print();
        document.body.innerHTML = originalContent;
        window.location.reload();
    };

    const handleDownload = () => {
        const receipt = printRef.current;
        const originalStyle = {
            height: receipt.style.height,
            overflowY: receipt.style.overflowY
        };
        receipt.style.height = "auto";
        receipt.style.overflowY = "visible";

        html2canvas(receipt, { 
            scale: 2,
            backgroundColor: '#f8f9fa'
        }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const imgWidth = 190;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
            pdf.save(`Receipt_${orderData.orderId || ''}.pdf`);
            
            receipt.style.height = originalStyle.height;
            receipt.style.overflowY = originalStyle.overflowY;
        });
    };

    useEffect(() => {
        if (!vendorId) return;

        const source = axios.CancelToken.source();

        (async () => {
            try {
                setLoading(true);
                const { data } = await axios.get(
                    ` https://backend.maamaas.com/food/banner/vendor/${vendorId}`,
                    { cancelToken: source.token }
                );

                const processedData = {
                    ...data,
                    companyName: data.companyName || "MAAMAAS",
                };

                setBannerData(processedData);
                setError("");
                localStorage.setItem("bannerData", JSON.stringify(processedData));
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error(err);
                    setError("Could not load banner details.");
                }
            } finally {
                setLoading(false);
            }
        })();

        return () => source.cancel();
    }, [vendorId]);

    return (
        <div className="receipt-container">
            <div ref={printRef} className="receipt-card">
                <div className="receipt-header">
                    <div className="success-badge">
                        <CheckCircle size={32} color="#10b981" />
                        <div>
                            <h1 className="success-title">Payment Successful</h1>
                            <p className="success-subtitle">Your order has been confirmed</p>
                        </div>
                    </div>
                    <div className="company-header">
                        <h2 className="company-name">{bannerData?.companyName || "MAAMAAS"}</h2>
                        <p className="invoice-label">INVOICE</p>
                    </div>
                </div>
                
                <div className="order-info-grid">
                    <div className="info-item">
                        <span className="info-label">Order ID</span>
                        <span className="info-value">{orderData.orderId || "N/A"}</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Date</span>
                        <span className="info-value">{formatDate(orderData.date)}</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Time</span>
                        <span className="info-value">{orderData.time || "N/A"}</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Order Type</span>
                        <span className="info-value">{orderData.orderType || "N/A"}</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Payment Method</span>
                        <span className="info-value">{orderData.paymentMethod || "N/A"}</span>
                    </div>
                    {orderData?.orderService === "Delivery" ? (
                        <div className="info-item full-width">
                            <span className="info-label">Delivery Location</span>
                            <span className="info-value">{orderData?.location || "N/A"}</span>
                        </div>
                    ) : (
                        <div className="info-item full-width">
                            {/* <span className="info-label">Outlet</span>
                            <span className="info-value">kphb Manjeera Trinity, 3rd gate straight line</span> */}
                        </div>
                    )}
                </div>
                
                {loading ? (
                    <div className="loading-state">
                        <div className="spinner"></div>
                        <p>Loading order details...</p>
                    </div>
                ) : Array.isArray(orderData.order) && orderData.order.length > 0 ? (
                    <div className="order-items-section">
                        <div className="table-header-row">
                            <span className="col-sno">S.No</span>
                            <span className="col-item">Item</span>
                            <span className="col-qty">Qty</span>
                            <span className="col-price">Price</span>
                            <span className="col-total">Total</span>
                        </div>
                        
                        <div className="items-list">
                            {orderData.order.map((item, index) => (
                                <div key={index} className="item-row">
                                    <span className="col-sno">{index + 1}</span>
                                    <span className="col-item">{item.dishName || item.order?.dishName || "N/A"}</span>
                                    <span className="col-qty">{item.quantity || 1}</span>
                                    <span className="col-price">₹{item.price ? parseFloat(item.price).toFixed(2) : "0.00"}</span>
                                    <span className="col-total">₹{calculateItemTotal(item).toFixed(2)}</span>
                                </div>
                            ))}
                        </div>
                        
                        <div className="charges-summary">
                            <div className="summary-row">
                                <span>Sub Total</span>
                                <span>₹{orderData?.subTotal || "0.00"}</span>
                            </div>
                            <div className="summary-row">
                                <span>Platform Charges</span>
                                <span>₹{orderData?.platformCharges || 0}</span>
                            </div>
                            <div className="summary-row">
                                <span>Packing Charges</span>
                                <span>₹{orderData?.serviceCharge || 0}</span>
                            </div>
                            <div className="summary-row">
                                <span>CGST</span>
                                <span>₹{orderData?.cgst || "0.00"}</span>
                            </div>
                            <div className="summary-row">
                                <span>SGST</span>
                                <span>₹{orderData?.sgst || "0.00"}</span>
                            </div>
                            <div className="summary-row total-row">
                                <span>Total Amount</span>
                                <span>₹{orderData?.totalAmount || 0}</span>
                            </div>
                            <div className="summary-row discount-row">
                                <span>Discount Applied</span>
                                <span>-₹{orderData?.discountAmount || 0}</span>
                            </div>
                            <div className="summary-row grand-total-row">
                                <span>Grand Total</span>
                                <span>₹{orderData?.grandTotal || "0.00"}</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="no-data-state">
                        <p>No order items available</p>
                    </div>
                )}
                
                <div className="thank-you-section">
                    <div className="thank-you-content">
                        <h3>Thank You for Your Order!</h3>
                        <p>We appreciate your business and look forward to serving you again.</p>
                        <div className="contact-info">
                            <span>www.maamaas.com</span>
                            <span className="divider">•</span>
                            <span>support@maamaas.com</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="action-buttons">
                <button className="btn btn-secondary" onClick={handlePrint}>
                    <Printer size={18} />
                    <span>Print Receipt</span>
                </button>
                <button className="btn btn-primary" onClick={handleDownload}>
                    <Download size={18} />
                    <span>Download PDF</span>
                </button>
            </div>
            
            {/* <div className="feedback-section">
                <div className="feedback-card">
                    <h3 className="section-titley">Share Your Experience</h3>
                    
                    <div className="feedback-content">
                        <div className="rating-section">
                            <h4>How would you rate us?</h4>
                            <div className="stars-container">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <button
                                        key={star}
                                        className={`star-btn ${rating >= star ? 'active' : ''}`}
                                        onClick={() => setRating(star)}
                                        onMouseEnter={() => setHover(star)}
                                        onMouseLeave={() => setHover(0)}
                                    >
                                        <Star size={28} fill={rating >= star ? "#ffc107" : "none"} />
                                    </button>
                                ))}
                            </div>
                            <p className="rating-text">
                                {rating > 0 ? `You rated ${rating} star${rating > 1 ? 's' : ''}` : 'Click to rate'}
                            </p>
                        </div>
                        
                        <div className="feedback-input">
                            <h4>Your Feedback</h4>
                            <textarea
                                value={feedback}
                                onChange={(e) => setFeedback(e.target.value)}
                                placeholder="Tell us about your experience..."
                                rows={4}
                            />
                        </div>
                    </div>
                    
                    <div className="submit-section">
                        <button 
                            className="btn-submit-feedback" 
                            onClick={handleSubmitFeedback}
                            disabled={!feedback.trim() && rating === 0}
                        >
                            Submit Feedback
                        </button>
                        <p className="helper-text">Your feedback helps us improve our service</p>
                    </div>
                </div>
            </div> */}
            
            {/* <div className="footer">
                @Envision Integrated Services Pvt Ltd - Empowering Your Future 🚀
            </div> */}
        </div>
    );
};

export default Sheduleorder;